var _mask, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 100,
    viewBox: "0 0 104 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1404_13794",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 50C0.5 22.3858 22.8858 0 50.5 0C78.1142 0 100.5 22.3858 100.5 50C100.5 77.6142 78.1142 100 50.5 100C22.8858 100 0.5 77.6142 0.5 50Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 50C0.5 22.3858 22.8858 0 50.5 0C78.1142 0 100.5 22.3858 100.5 50C100.5 77.6142 78.1142 100 50.5 100C22.8858 100 0.5 77.6142 0.5 50Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H100.5H0.5ZM100.5 100H0.5H100.5ZM0.5 100V0V100ZM53.5 0C81.1142 0 103.5 22.3858 103.5 50C103.5 77.6142 81.1142 100 53.5 100H50.5C76.4574 100 97.5 77.6142 97.5 50C97.5 22.3858 76.4574 0 50.5 0H53.5Z",
    fill: "url(#paint0_linear_1404_13794)",
    mask: "url(#path-1-inside-1_1404_13794)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8007 29.4649C23.8007 26.2248 26.4277 23.5978 29.6679 23.5978H70.7378C73.978 23.5978 76.605 26.2248 76.605 29.4649V70.5349C76.605 73.7736 73.978 76.402 70.7378 76.402H29.6679C26.4277 76.402 23.8007 73.7736 23.8007 70.5349V29.4649Z",
    fill: "#FF6D00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8007 29.4649V47.0179L29.6679 52.8851C29.6679 52.8851 46.0269 71.7787 59.0036 58.8006C71.9802 45.8225 53.1643 30.9317 53.1643 30.9317L45.823 23.5978H29.6679C26.4277 23.5978 23.8007 26.2233 23.8007 29.4649Z",
    fill: "#E64A19"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1643 30.9318C69.9282 42.2231 64.5055 54.6746 64.5055 54.6746C64.5055 54.6746 69.2725 60.0049 67.3451 64.6678C67.3451 64.6678 65.3797 61.4027 62.0823 61.4027C58.9053 61.4027 57.0366 64.6678 50.6414 64.6678C36.4019 64.6678 29.6678 52.8851 29.6678 52.8851C42.4978 61.2458 51.2575 55.3244 51.2575 55.3244C45.4769 52.0007 32.6014 35.3321 32.6014 35.3321C43.3075 44.3602 48.736 47.0664 48.736 47.0664C45.9756 44.8046 37.0018 33.8653 37.0018 33.8653C43.1975 40.0816 56.5203 49.0876 56.5203 49.0876C60.0171 39.489 53.1643 30.9318 53.1643 30.9318Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1404_13794",
    x1: 50.5,
    y1: 0,
    x2: 50.5,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F25823"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/IOS.4e2c40e767b0e18102b56308bad2b5ba.svg";
export { ForwardRef as ReactComponent };